const STORAGE_KEY = "hearing_app_queue_v1";

const DEFAULT_STORE = {
  patientDraft: null,
  uploadQueue: [],
};

export function saveStore(store) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {
    console.error("An error occurred:", error.message);
  }
}

export function getStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return { ...DEFAULT_STORE };
    }

    const parsed = JSON.parse(raw);
    return parsed;

  } catch (error) {
    console.error("An error occurred:", error.message);
    return { ...DEFAULT_STORE };
  }
}
